import React, {useEffect, useState} from 'react';
import LayoutContainer from '../base/LayoutContainer';
import axios from 'axios';
import './PostPage.css';
import {Remarkable} from 'remarkable';
import {Link} from 'react-router-dom';
import {Button, Col, Container, Row, Spinner} from 'react-bootstrap';
import {Helmet} from 'react-helmet';
import DOMPurify from 'dompurify';
import {useTheme} from '../themes/useTheme';
import {SITE_NAME} from '../site';

const initialPost = {
  title: '',
  content: '',
  pubDate: '',
  tags: '',
  pid: '',
};

const md = new Remarkable({
  html: true,
});

const PostPage = () => {

  const [post, setPost] = useState(initialPost);
  const theme = useTheme();

  const postId = window.location.href.split('/')[5];

  useEffect(() => {
    if (postId !== undefined && postId !== '' && post.title === '') {
      axios.get(`https://rohitkulky.com/base/api/p?p=${postId}`).
          then(response => {
            console.log(response);
            setPost(response.data);
            document.title = post.title ?? '...';
          }).
          catch(error => console.error(
              `There was an error retrieving the post: ${error}`));
    }
  }, []);

  if (post && post.title === '') {
    return <LayoutContainer>
      <Container className={'middleCenter'}>
        <Spinner animation={'grow'} size={'lg'}/>
      </Container>
    </LayoutContainer>;
  }

  // Create a clean description from content (remove markdown, limit length)
  const cleanDescription = post.content
    .replace(/[#*`[\]()]/g, '') // Remove markdown characters
    .replace(/\n/g, ' ') // Replace newlines with spaces
    .trim()
    .substring(0, 160) + (post.content.length > 160 ? '...' : '');

  const postUrl = `https://rohitkulky.com/blog/post/${postId}`;
  const imageUrl = 'https://rohitkulky.com/imageurl.png';

  const head = (
          <Helmet>
            <title>{post.title}</title>
            <meta name="description" content={cleanDescription} />
            <link rel="canonical" href={postUrl} />
            
            {/* Open Graph / Facebook */}
            <meta property="og:type" content="article" />
            <meta property="og:url" content={postUrl} />
            <meta property="og:title" content={post.title} />
            <meta property="og:description" content={cleanDescription} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:secure_url" content={imageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="article:published_time" content={post.pubDate} />
            {post.tags && <meta property="article:tag" content={post.tags} />}
            
            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={postUrl} />
            <meta name="twitter:title" content={post.title} />
            <meta name="twitter:description" content={cleanDescription} />
            <meta name="twitter:image" content={imageUrl} />
          </Helmet>
  );

  if (theme === 'paper') {
    const tags = post.tags.split(',').map(t => t.trim().toLowerCase()).filter(Boolean);
    return (
      <LayoutContainer>
        {head}
        <article className="paper-post">
          <header>
            <h1 className="paper-post-title">{post.title}</h1>
            <p className="paper-post-meta">{post.pubDate} · {tags.map((t, i) => <span key={t}>{i > 0 && ' / '}<Link to={'/blog/type/' + t}>{t}</Link></span>)}</p>
          </header>
          <div className="postMainContent paper-post-body">
            <div dangerouslySetInnerHTML={{__html: md.render(DOMPurify.sanitize(post.content))}}/>
          </div>
          <footer className="paper-post-foot">
            <p className="paper-pageno">— {post.pid} —</p>
            <Link to="/">← back to contents</Link>
          </footer>
        </article>
      </LayoutContainer>
    );
  }

  return (
      <LayoutContainer>
        <Container style={{width: 'max(50vw, 500px)'}}>
          {head}
          <Row>
            <div className="twelve columns middleCenter postMainTitle"
                 style={{color: 'black'}}>
              {post.title}
            </div>
          </Row>
          <Row>
            <Col style={{
              fontSize: '1rem',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              color: 'azure',
              textShadow: '0 0 1px black'
            }}>
              {SITE_NAME}
            </Col>
          </Row>
          <Row>
            <div className="postMainContent pt-4">
              <div className={'pt-4'} dangerouslySetInnerHTML={{
                __html: md.render(DOMPurify.sanitize(post.content)),
              }}/>
            </div>
          </Row>
          <Row>
            <Col style={{
              fontSize: '1rem',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              color: 'azure',
              textShadow: '0 0 1px black'
            }}>
              {post.pubDate}
            </Col>
          </Row>
          <Row>
            <Col style={{display: 'flex', justifyContent: 'end'}}>
              {
                post.tags.split(',').map(t => {
                  return <Link style={{
                    textDecoration: 'none',
                    color: 'azure',
                    paddingRight: 5,
                    textShadow: '0 0 1px black'
                  }} key={t.trim()} to={'/blog/type/' + t.trim().toLowerCase()}> {t.trim().toLowerCase()} </Link>;
                })
              }
            </Col>
          </Row>
          <Row className="pt-5 pb-5 mt-5 mb-5">
            <Link to="/">
              <Button style={{fontSize: '1rem'}}
                      variant="outline-light" type="submit">
                Back Home
              </Button>
            </Link>
          </Row>
        </Container>
      </LayoutContainer>
  )
      ;
};

export default PostPage;
